import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormLabel } from '@material-ui/core';
import FormControl from '../FormControl/FormControl';
import styles from './FormField.scss';

const FormField = ({ className, label, children }) =>
    <FormControl className={classnames(styles.baseFormField, className)}>
        <FormLabel className={styles.baseLabel}>{ label }</FormLabel>
        { children }
    </FormControl>;

FormField.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    children: PropTypes.node
};

export default FormField;

